import React from 'react';
import * as RxSelect from '@radix-ui/react-select';
import './Select.css';

function ChevronDownIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}

function CheckIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

function Select({
  value,
  onChange,
  options = [],
  placeholder = 'Select...',
  size = 'md',
  error = false,
  disabled = false,
  fullWidth = false,
  'aria-label': ariaLabel,
  className = '',
}) {
  const triggerClasses = [
    'ui-select',
    `ui-select--${size}`,
    error ? 'ui-select--error' : '',
    fullWidth ? 'ui-select--full' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <RxSelect.Root value={value} onValueChange={onChange} disabled={disabled}>
      <RxSelect.Trigger className={triggerClasses} aria-label={ariaLabel} aria-invalid={error || undefined}>
        <RxSelect.Value placeholder={placeholder} />
        <RxSelect.Icon className="ui-select__icon">
          <ChevronDownIcon />
        </RxSelect.Icon>
      </RxSelect.Trigger>
      <RxSelect.Portal>
        <RxSelect.Content className="ui-select__content" position="popper" sideOffset={4}>
          <RxSelect.Viewport className="ui-select__viewport">
            {options.map((opt) => (
              <RxSelect.Item key={opt.value} value={opt.value} className="ui-select__item" disabled={opt.disabled}>
                <RxSelect.ItemText>{opt.label}</RxSelect.ItemText>
                <RxSelect.ItemIndicator className="ui-select__indicator">
                  <CheckIcon />
                </RxSelect.ItemIndicator>
              </RxSelect.Item>
            ))}
          </RxSelect.Viewport>
        </RxSelect.Content>
      </RxSelect.Portal>
    </RxSelect.Root>
  );
}

export default Select;
